import { faGlobe } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import XButton from "assets/icons/x_button.svg";
import { customStylesHighZIndex } from "constants/customStyles";
import {
  COMMON_NAMESPACE,
  LANGUAGE_MODAL_NAMESPACE,
} from "constants/i18n-namespaces";
import { TextButton } from "kubra-ux-forge";
import { useTranslation } from "react-i18next";
import Modal from "react-modal";
import Sheet from "react-modal-sheet";
import { LanguageModal } from "../language-modal";
import { StyledLanguageMobileButton } from "../menu/styled-components";

export interface LanguageMenuProps {
  isMobile: boolean;
  languageModalDisplay: boolean;
  closeLanguagesModal: () => void;
  getLanguageDisplayValue: (language: string) => string;
  setLanguageModalDisplay: (display: boolean) => void;
  i18nLang: string;
}

export const LanguageMenu = ({
  isMobile,
  languageModalDisplay,
  closeLanguagesModal,
  setLanguageModalDisplay,
  getLanguageDisplayValue,
  i18nLang,
}: LanguageMenuProps) => {
  const { t } = useTranslation();

  return (
    <>
      {/* language menu button */}
      {!isMobile && (
        <TextButton
          // @ts-ignore
          icon={
            <FontAwesomeIcon
              icon={faGlobe}
              role="img"
              aria-label={t("header", { ns: LANGUAGE_MODAL_NAMESPACE })}
            />
          }
          onClick={() => {
            setLanguageModalDisplay(true);
          }}
          dataCy="button-language"
          aria-label={getLanguageDisplayValue(i18nLang)}
        >
          {getLanguageDisplayValue(i18nLang)}
        </TextButton>
      )}
      {isMobile && (
        <StyledLanguageMobileButton
          // @ts-ignore
          icon={
            <FontAwesomeIcon
              icon={faGlobe}
              role="img"
              aria-label={t("header", { ns: LANGUAGE_MODAL_NAMESPACE })}
            />
          }
          onClick={() => {
            setLanguageModalDisplay(true);
          }}
          dataCy="button-language"
          aria-label={getLanguageDisplayValue(i18nLang)}
        >
          {getLanguageDisplayValue(i18nLang)}
        </StyledLanguageMobileButton>
      )}
      {/* language modal and sheet */}
      {isMobile && (
        <Sheet
          isOpen={languageModalDisplay}
          onClose={closeLanguagesModal}
          disableDrag={true}
          detent="content-height"
          aria-labelledby="language-modal-header-mobile"
        >
          <Sheet.Container>
            <Sheet.Header>
              <div className="react-modal-sheet-header heading-style-override">
                <h2
                  className="help-modal-header-text"
                  id="language-modal-header-mobile"
                >
                  {t("header", { ns: LANGUAGE_MODAL_NAMESPACE })}
                </h2>
                <button
                  className="modal-close"
                  onClick={closeLanguagesModal}
                  data-cy="modal-close-x-language"
                >
                  <img
                    src={XButton}
                    alt={`${t("close-modal", { ns: COMMON_NAMESPACE })}`}
                    className="modal-close-x"
                  />
                </button>
              </div>
            </Sheet.Header>
            <Sheet.Content>
              <LanguageModal onClose={closeLanguagesModal} />
            </Sheet.Content>
          </Sheet.Container>
          {/* @ts-ignore */}
          <Sheet.Backdrop onClick={closeLanguagesModal} />
        </Sheet>
      )}
      {!isMobile && (
        // @ts-ignore
        <Modal
          isOpen={languageModalDisplay}
          ariaHideApp={false}
          className="modal-frame-help"
          shouldCloseOnOverlayClick={true}
          onRequestClose={closeLanguagesModal}
          style={customStylesHighZIndex}
          aria={{
            labelledby: "language-modal-header",
          }}
        >
          <div className="modal-header heading-style-override">
            <h2 className="help-modal-header-text" id="language-modal-header">
              {t("header", { ns: LANGUAGE_MODAL_NAMESPACE })}
            </h2>
            <button
              className="modal-close"
              onClick={closeLanguagesModal}
              data-cy="modal-close-x-help"
            >
              <img
                src={XButton}
                alt={`${t("close-modal", { ns: COMMON_NAMESPACE })}`}
                className="modal-close-x"
              />
            </button>
          </div>
          <LanguageModal onClose={closeLanguagesModal} />
        </Modal>
      )}
    </>
  );
};

export default LanguageMenu;
